import React, { FunctionComponent } from 'react';

import { SvgProps, propsHelperRem } from '@/shared/lib/propsHelper';

const Eye: FunctionComponent<SvgProps> = (props) => (
    <svg {...propsHelperRem(2.4, 2.5, props)}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.33 14.485c.757-.698 1.4-1.4 1.891-1.985a21.948 21.948 0 0 0-1.892-1.985C16.422 8.76 14.182 7.4 12 7.4c-2.182 0-4.422 1.36-6.33 3.115-.757.698-1.4 1.4-1.891 1.985a21.94 21.94 0 0 0 1.892 1.985C7.578 16.24 9.818 17.6 12 17.6c2.182 0 4.422-1.36 6.33-3.115ZM12 5C5.787 5 .75 12.5.75 12.5S5.787 20 12 20s11.25-7.5 11.25-7.5S18.213 5 12 5Zm9.26 6.159ZM15 12.499a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        />
    </svg>
);

export default Eye;
